/**
 * LAS DOS CLAVES DEL NOMBRE DE UN CULTIVO (01-10-2026, plan cultivos SIEX).
 *
 * `claveLatina` es el GEMELO EXACTO de la función SQL `public.crop_key(text)`
 * (migración 20261001100000_crop_catalog.sql): con ella se guardan
 * `crop_catalog.name_key`, `crop_catalog_alias.alias_key` y
 * `crop_variety_catalog.name_key`. Si el navegador, la edge y la BD no sacan la
 * MISMA clave de «Calabacín», un alias guardado desde aquí no lo encuentra la
 * BD y viceversa. La receta es la del SQL, paso a paso y en este orden:
 *
 *   lower() → translate('áàäâãéèëêíìïîóòöôõúùüûñç', 'aaaaaeeeeiiiiooooouuuunc')
 *   → cada tramo que no sea [a-z0-9] pasa a un espacio → espacios colapsados
 *   → btrim → '' = NULL.
 *
 * Sin `normalize('NFD')` a propósito: Postgres no la hace y una «á» escrita
 * como «a» + tilde combinante sale igual de rara en los dos lados. El test
 * `cropKey.parity.test.ts` lo compara con una reimplementación literal del SQL.
 * Solo vale para alfabeto latino: «番茄» o «Konkɔnbɛrɛ» se quedan sin clave o
 * con una clave rota, y por eso existe la otra.
 *
 * `claveBusqueda` es la de buscar y resolver en la app: quita las tildes de
 * cualquier alfabeto (NFD), pasa a minúsculas y deja letras y dígitos de
 * CUALQUIER escritura. Así «番茄», «طماطم», «Melɔn» (bambara) y «Sòso»
 * (mandinga) se encuentran, que son los nombres por defecto de la app en sus
 * nueve idiomas. Para un nombre castellano corriente las dos claves coinciden.
 *
 * PURO: sin red ni imports (viaja a Deno en _shared/cultivosCurados.generated.ts).
 */

const CON_TILDE = "áàäâãéèëêíìïîóòöôõúùüûñç";
const SIN_TILDE = "aaaaaeeeeiiiiooooouuuunc";
const TRADUCE: ReadonlyMap<string, string> = new Map([...CON_TILDE].map((c, i) => [c, SIN_TILDE[i]]));

/** Gemelo de `public.crop_key(text)`: «  Calabacín (Zucchini) » → «calabacin zucchini»; «» → null. */
export function claveLatina(s: string | null | undefined): string | null {
  if (s == null) return null;
  let t = "";
  for (const c of String(s).toLowerCase()) t += TRADUCE.get(c) ?? c;
  const k = t.replace(/[^a-z0-9]+/g, " ").replace(/ +/g, " ").trim();
  return k === "" ? null : k;
}

/** La clave de buscar: «Pastèque» → «pasteque»; «Konkɔnbɛrɛ» → «konkɔnbɛrɛ»; «番茄» → «番茄». '' si no queda nada. */
export function claveBusqueda(s: string | null | undefined): string {
  return String(s ?? "")
    .normalize("NFD")
    .replace(/\p{M}+/gu, "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .replace(/ +/g, " ")
    .trim();
}
